<ng-container *transloco="let t">

  <div class="container pt-2">

    <app-activity-about
      [activity]="activity()"
      [isPreview]="isPreview()"
      [hostUrl]="hostUrl()"
      [canEdit]="false"
      [canManageTags]="false">
    </app-activity-about>

    <app-activity-schedules
      [activity]="activity()"
      [isPreview]="isPreview()">
    </app-activity-schedules>

    <app-activity-price
      [activity]="activity()">
    </app-activity-price>

    <app-activity-links
      [activity]="activity()"
      [showAlways]="false">
    </app-activity-links>

    <app-activity-host
      [activity]="activity()"
      [hostUrl]="hostUrl()"
      [isPreview]="isPreview()"
      #activityHost>
    </app-activity-host>

  </div>
</ng-container>
